import 'es6-promise/auto'
import 'es6-object-assign/auto'

import Vue from 'vue'
import VueCompositionAPI from '@vue/composition-api'
import router from './router'
import store from './store'
import VueCookie from 'vue-cookie'
import VueTouch from 'vue-touch'
import infiniteScroll from 'vue-infinite-scroll'
import userAgent from '@/libs/user-agent'
import mobileApp from '@/libs/mobile-app'
import VueGtm from 'vue-gtm'
import VueTour from 'vue-tour'
import i18n from './i18n'
import VueMeta from 'vue-meta'
import SyntaxHighlighter from '@/components/Inputs/QuillEditor/SyntaxHighlighter'
import LogRocket from 'logrocket'

const App = () => import('@/components/App').then(({ App }) => App(process.env.APP_NAME))

Vue.config.productionTip = false

Vue.use(VueCompositionAPI)
Vue.use(VueCookie)
Vue.use(VueTouch)
Vue.use(VueMeta)
Vue.use(infiniteScroll)
Vue.use(VueTour)
Vue.use(SyntaxHighlighter)

Vue.prototype.$isProjects = (process.env.APP_NAME !== 'Neweng')

// Check environments
Vue.prototype.$isStaging = true
Vue.prototype.$isProduction = false

if (process.env.NODE_ENV === 'development') {
  Vue.prototype.$environment = 'Local'
} else if (process.env.STAGING === 'true') {
  Vue.prototype.$environment = 'Staging'
} else if (process.env.QA === 'true') {
  Vue.prototype.$environment = 'QA'
} else if (process.env.PP === 'true') {
  Vue.prototype.$environment = 'PreProd'
} else if (process.env.NODE_ENV === 'production') {
  Vue.prototype.$environment = 'Prod'
  Vue.prototype.$isProduction = true
  Vue.prototype.$isStaging = false
}

Vue.prototype.$isStories = process.env.APP_NAME === 'Neweng'
Vue.prototype.$isYSC = process.env.APP_NAME === 'Ysc'
Vue.prototype.$isHeise = process.env.APP_NAME === 'Heise'
Vue.prototype.$isAjas = process.env.APP_NAME === 'Ajas'
Vue.prototype.$isIsef = process.env.APP_NAME === 'Isef'
Vue.prototype.$isMake = (process.env.APP_NAME === 'Make') || (process.env.APP_NAME === 'Heise')
Vue.prototype.$isProjectboard = process.env.APP_NAME === 'Projectboard'
Vue.prototype.$isGirlsAndSteam = process.env.APP_NAME === 'Girls-and-steam'
Vue.prototype.$isBroadcomMasters = process.env.APP_NAME === 'Societyforsciencebcm'
Vue.prototype.$isOhioScience = process.env.APP_NAME === 'Ohiosci'
Vue.prototype.$isCnmiIwsf = process.env.APP_NAME === 'Cnmiiwsf'
Vue.prototype.$isBuckeye = process.env.APP_NAME === 'Buckeye'
Vue.prototype.$isSts = process.env.APP_NAME === 'Sts'
Vue.prototype.$isOasam = process.env.APP_NAME === 'Oasam'
Vue.prototype.$isSigmaXi = process.env.APP_NAME === 'Sigmaxi'
Vue.prototype.$isEngComApp = userAgent.isEngComApp()
Vue.prototype.$isProjectBoardApp = userAgent.isProjectBoardApp()

Vue.prototype.$partner = process.env.APP_NAME.toLowerCase().replace(/"/g, '')

Vue.prototype.$isApp = Vue.prototype.$isEngComApp || Vue.prototype.$isProjectBoardApp

// brand as eng.com?
Vue.prototype.$isEngCom = Vue.prototype.$isEngComApp || Vue.prototype.$isStories

Vue.prototype.$webRoot = process.env.WEB_ROOT
Vue.prototype.$microsoftClientId = process.env.MICROSOFT_CLIENT_ID

let titleTemplate
let metaDescription

const today = new Date()
const year = today.getFullYear()
var LOGROCKET_KEEP_REQUEST_MULTIPLE = 1
var LOGROCKET_DISABLE = false
var LOGROCKET_ID = 'bm62x7/projectboard-other'

// default algolia PB instance
Vue.prototype.$algoliaApplicationId = 'N7R6V0TX23'
Vue.prototype.$algoliaAPIKey = '136c9d64ab3dddb820445df5d1e22d39'

switch (process.env.APP_NAME) {
  case 'Neweng':
    titleTemplate = (titleChunk) => titleChunk === '' ? 'Engineering.com' : `${titleChunk} | Engineering.com`
    metaDescription = 'Engineering information and connections for the global community of engineers. Find engineering games, videos, jobs, disciplines, calculators and articles…'
    LOGROCKET_KEEP_REQUEST_MULTIPLE = 25
    LOGROCKET_DISABLE = true
    LOGROCKET_ID = 'bm62x7/engineeringcom'
    Vue.prototype.$algoliaApplicationId = '9M1OA4RJEO'
    Vue.prototype.$algoliaAPIKey = '3731af80fcfebbf65f9551ae1c066755'
    break

  case 'Ysc':
    titleTemplate = (titleChunk) => titleChunk === '' ? 'ProjectBoard: YSC' : `${titleChunk} | ProjectBoard: YSC`
    metaDescription = 'Ysc: Projects is your all in one workplace for STEM minds to share ideas, take action and solve problems, big and small!'
    LOGROCKET_ID = 'bm62x7/projectboard-ysc'
    break

  case 'Make':
    titleTemplate = (titleChunk) => titleChunk === '' ? 'Make: Projects' : `${titleChunk} | Make: Projects`
    metaDescription = 'Make: Projects is your all in one workplace for STEM minds to share ideas, take action and solve problems, big and small!'
    LOGROCKET_ID = 'bm62x7/projectboard-make'
    LOGROCKET_DISABLE = true
    break

  case 'Heise':
    titleTemplate = (titleChunk) => titleChunk === '' ? 'Make: Projects De' : `${titleChunk} | Make: Projects De`
    metaDescription = 'Zusammen mehr machen. Die kostenfreie Projektplattform für Maker, Erfinder, DIY-Fans und Handwerker. Ladet eure Projekte hoch, teilt eure Ideen, holt euch Feedback, lernt andere Maker kennen und arbeitet gemeinsam an Projekten.'
    break

  case 'Ajas':
    titleTemplate = (titleChunk) => titleChunk === '' ? 'AJAS Virtual Poster Session' : `${titleChunk} | AJAS Virtual Poster Session`
    metaDescription = `Welcome to the ${year} AJAS Virtual Poster Session`
    break

  case 'Girls-and-steam':
    titleTemplate = (titleChunk) => titleChunk === '' ? 'Girls and STEAM' : `${titleChunk} | Girls and STEAM`
    metaDescription = 'Girls and STEAM'
    break

  case 'Isef':
    titleTemplate = (titleChunk) => titleChunk === '' ? 'Regeneron ISEF 2023' : `${titleChunk} | Regeneron ISEF 2023`
    metaDescription = 'Regeneron ISEF 2023'
    LOGROCKET_ID = 'bm62x7/projectboard-isef'
    break

  case 'Projectboard':
    titleTemplate = (titleChunk) => titleChunk === '' ? 'ProjectBoard' : `${titleChunk} | ProjectBoard`
    metaDescription = 'ProjectBoard: We are the Social Platform for STEM projects'
    break

  case 'Ohiosci':
    titleTemplate = (titleChunk) => titleChunk === ' ' ? 'The Ohio Academy of Science' : `${titleChunk} | The Ohio Academy of Science`
    metaDescription = 'Welcome to the Project Portal for Believe in Ohio and Science Day, programs by The Ohio Academy of Science, with the mission of creating a culture of innovation and advancement for middle and high school students in Ohio. Powered by ProjectBoard, students & teachers can take action together through step-by-step mileposts to develop, define and refine ideas in realtime, online.'
    LOGROCKET_ID = 'bm62x7/projectboard-oas'
    break

  case 'Cnmiiwsf':
    titleTemplate = (titleChunk) => titleChunk === '' ? 'STEM' : `${titleChunk} | STEM`
    metaDescription = 'STEM'
    LOGROCKET_ID = 'bm62x7/projectboard-cnmi'
    break

  case 'Buckeye':
    titleTemplate = (titleChunk) => titleChunk === '' ? 'Buckeye' : `${titleChunk} | Buckeye`
    metaDescription = 'Buckeye Science Engineering Fair'
    LOGROCKET_ID = 'bm62x7/projectboard-buckeye'
    break

  case 'Oasam':
    titleTemplate = (titleChunk) => titleChunk === '' ? 'OASAM' : `${titleChunk} | OASAM`
    metaDescription = 'ProjectBoard: We are the Social Platform for STEM projects'
    LOGROCKET_ID = 'bm62x7/projectboard-oasam'
    break

  case 'Societyforsciencebcm':
    titleTemplate = 'Broadcom MASTERS'
    metaDescription = 'Broadcom MASTERS International is a companion program to the domestic Broadcom MASTERS Competition and provides a unique opportunity for select middle school students from around the world to observe the International Science and Engineering Fair (ISEF).'
    LOGROCKET_ID = 'bm62x7/projectboard-bcm'
    break

  case 'Sigmaxi':
    titleTemplate = 'Sigma Xi | Student Research Showcase'
    metaDescription = 'Sigma Xi | Student Research Showcase'
    LOGROCKET_ID = 'bm62x7/projectboard-sigma-xi'
    break

  default:
    titleTemplate = '%s ProjectBoard'
    metaDescription = 'ProjectBoard: We are the Social Platform for STEM projects'
}

if (!String.prototype.trim) {
  // eslint-disable-next-line no-extend-native
  String.prototype.trim = function () {
    return this.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '')
  }
}

if (!String.prototype.includes) {
  // eslint-disable-next-line no-extend-native
  String.prototype.includes = function (search, start) {
    'use strict'

    if (search instanceof RegExp) {
      throw TypeError('first argument must not be a RegExp')
    }
    if (start === undefined) {
      start = 0
    }
    return this.indexOf(search, start) !== -1
  }
}

const init = function () {
  window.vueInitialized = true

  if (typeof Event === 'function') {
    document.dispatchEvent(new Event('vueInitialized'))
  }

  if (Vue.prototype.$isProduction && !LOGROCKET_DISABLE) {
    // only initialize Logrocket x% of the time to reduce session counts
    const rndInt = Math.floor(Math.random() * LOGROCKET_KEEP_REQUEST_MULTIPLE) + 1
    if (rndInt === 1) {
      LogRocket.init(LOGROCKET_ID, {
        release: process.env.RELEASE_VERSION
      })
    }
  }

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    i18n,
    render: h => h(App),
    template: '<App ref="app" />',
    components: { App },
    metaInfo: {
      title: '',
      titleTemplate,
      meta: [
        {
          charset: 'utf-8',
          vmid: 'description',
          name: 'description',
          content: metaDescription
        }
      ]
    },
    created: function () {
      if (userAgent.isApp()) {
        mobileApp.startListeners(this)
      }
      this.$cookie.set('gtm_tracking_id', process.env.UA_ID)
    },
    destroyed: function () {
      if (userAgent.isApp()) {
        mobileApp.stopListeners()
      }
    }
  })
}

if (userAgent.isApp() && !window.appOnline) {
  document.addEventListener(mobileApp.events.online, init, false)
} else {
  init()
}

Vue.use(VueGtm, {
  vueRouter: router,
  enabled: true,
  loadScript: false, // We manually add the scripts in index.dev.html and index.prod.html for it to load before Vue
  ignoredViews: ['viewStory', 'articleRedirect'] // ignore viewStory since we're tracking with the trackStory datalayer push
})
